import { useEffect, useState } from "react";
import { checkSettings } from "../utils/util";
import { getCustomTags } from "../services/api-service";

export default function useCustomTags({ needCustomTags = false } = { needCustomTags: false }) {
    const [enableCustomTags, setEnableCustomTags] = useState(false);
    const [loadingCustomTags, setLoadingCustomTags] = useState(false);
    const [customTagList, setCustomTagList] = useState([]);

    async function checkCustomTags() {
        try {
            setLoadingCustomTags(true);
            const resp = await checkSettings("CUSTOM_TAGS");
            if (resp && (resp === true || resp === "true")) {
                setEnableCustomTags(true);
            } else {
                setEnableCustomTags(false);
            }
        } catch (error) {
            console.error("Error checking sub user chat", error);
        } finally {
            setLoadingCustomTags(false);
        }
    }

    useEffect(() => {
        checkCustomTags();
    }, []);

    useEffect(() => {
        if (enableCustomTags && needCustomTags) {
            const controller = new AbortController();
            getCustomTagList(controller);
            return () => controller.abort();
        }
    }, [enableCustomTags, needCustomTags]);

    async function getCustomTagList(controller) {
        try {
            const resp = await getCustomTags(controller);
            if (resp.Status === "Success" && resp.Data && Array.isArray(resp.Data) && resp.Data.length > 0) {
                let customTagList = resp.Data.reduce((acc, item) => {
                    if (!item.isActive) {
                        return acc;
                    }
                    try {
                        if (item && typeof item === "object" && "tagValue" in item && item.tagValue && typeof item.tagValue === "string" && item.tagValue.length > 0) {
                            item.tagValue = JSON.parse(item.tagValue)[0][item.tagName] || [];
                        } else {
                            resp.Data.tagValue = [];
                        }
                    } catch (e) {
                        console.log("Error in custom tag list", e);
                        item.tagValue = [];
                    }
                    acc.push({ tagName: item.tagName, tagValue: item.tagValue });
                    return acc;
                }, []);
                setCustomTagList(customTagList);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    return { enableCustomTags, loadingCustomTags, checkCustomTags, customTagList };
}
